export class TokenVO {
    token: string;
    expirationDateTime: Date;

    /** Quando true, o token tem escopo "reativacao" e o frontend deve redirecionar pra /reativacao. */
    requiresReactivation: boolean;
    /** "SuspensaInadimplencia" | "Cancelada" — informativo, só vem com requiresReactivation. */
    situacao: string | null;

    constructor(p: any) {
      this.token = p.token !== undefined ? p.token : null;
      this.expirationDateTime = p.expirationDateTime !== undefined ? p.expirationDateTime : null;
      this.requiresReactivation = !!p.requiresReactivation;
      this.situacao = p.situacao ?? null;
    }
}
